import { useCallback, useContext, useEffect, useState } from "react";
import { TripContext } from "./tripContext";
import { decrypt, encrypt } from "../../utils/customFunctions";

export function TripProvider({children}){
    const maxAllowedTours = 10;
    const TRIP_STORAGE_KEY = "TRIPS";

    const [pastTours, setPastTours] = useState([]);

    const [activeTour, setActiveTour] = useState([{lat: -1, lng: -1}, {lat: -1, lng: -1}]);

    const [editTourData, setEditTourData] = useState(null);

    useEffect(() => {
        const localData = localStorage.getItem(TRIP_STORAGE_KEY);

        if(localData){
            const decryptedString = decrypt(localData);
            const array = JSON.parse(decryptedString);

            setPastTours(array);
        }
    }, []);

    const addNewTour = useCallback((tour, name) => {
        tour.UUID = new Date().getTime();
        tour.name = name;
        
        const allowedTours = deleteOldestTour();

        setPastTours([tour, ...allowedTours]);
        localStorage.setItem(TRIP_STORAGE_KEY, encrypt([tour, ...allowedTours]));
    }, [pastTours]);

    const editTour = useCallback((summaryData) => {
        setEditTourData(summaryData);
    }, []);

    const updateDistance = useCallback((distance) => {
        setEditTourData((prevObj) => ({
            ...prevObj,
            distance: distance
        }));
    }, []);

    const updateTime = useCallback((time) => {
        setEditTourData((prevObj) => ({
            ...prevObj,
            time: time
        }));
    }, []);

    const updateCoordinates = useCallback((locations) => {
        setEditTourData((prevObj) => ({
            ...prevObj,
            locations: locations
        }));
    }, []);

    const clearEditTourHistory = useCallback(() => {
        setEditTourData(null);
    }, []);

    const deleteATour = useCallback((tourID) => {
        const newToursArray = [...pastTours];
        let itemIndex = -1;

        for(let i = 0; i < newToursArray.length; i++){
            if(newToursArray[i].UUID == tourID){
                itemIndex = i;
                break;
            }
        }

        if(itemIndex != -1){
            newToursArray.splice(itemIndex, 1);
        }

        setPastTours(newToursArray);
        localStorage.setItem(TRIP_STORAGE_KEY, encrypt(newToursArray));
    }, [pastTours]);

    const clearAllTours = useCallback(() => {
        setPastTours([]);
        localStorage.removeItem(TRIP_STORAGE_KEY);
    }, []);

    const deleteOldestTour = useCallback(() => {
        if(pastTours.length >= maxAllowedTours){
            const array = [...pastTours];
            array.splice(maxAllowedTours - 1);
            
            return array;
        }

        return pastTours;
    }, [pastTours]);

    const clearActiveTour = useCallback(() => {
        setActiveTour([{lat: -1, lng: -1}, {lat: -1, lng: -1}]);
    }, []);

    const value = {
        pastTours,
        addNewTour,
        deleteATour,
        clearAllTours,
        updateDistance,
        updateTime,
        updateCoordinates,

        setActiveTour,
        activeTour,
        clearActiveTour,

        editTourData,
        editTour,
        clearEditTourHistory
    }

    return (
        <TripContext.Provider value={value}>
            {children}
        </TripContext.Provider>
    );
}

export const GetPastTrips = () => {
    return useContext(TripContext);
};